import { ParagraphProps } from '../../../components/PageBuilder/Paragraph/Paragraph';
import WhatISImage from '../../../assets/images/unique/Functional Medicine/functional-medicine-doctor.jpg';

export const FunctionalMedicineParagraphs: ParagraphProps[] = [
  {
    title: 'What it consists of',
    text: `Functional medicine is a way of organizing health information around patterns instead of isolated symptoms. The conversation can include sleep, digestion, nutrition, stress, movement, medical history, environment, medications, and lab trends to understand what may be driving a concern.`,
    img: WhatISImage,
  },
  {
    title: 'What it may help clarify',
    text: `This approach may help organize questions around fatigue, digestive discomfort, inflammation, sleep disruption, metabolic changes, stress load, recovery after illness, or symptoms that feel connected but difficult to explain. Context helps decide what deserves attention first.`,
  },
  {
    title: 'What is reviewed in consultation',
    text: `Useful information includes a timeline of symptoms, previous diagnoses, medications, supplements, lab work, food patterns, sleep schedule, movement habits, and major stressors. This turns the appointment into a clearer map rather than a list of disconnected complaints.`,
  },
  {
    title: 'What to keep in mind',
    text: `The goal is not to chase every possible cause at once. A thoughtful plan should define priorities, follow-up, and ways to evaluate progress. Better questions can lead to a focused next step that makes sense medically and practically.`,
  },
];
